import { render } from "./TipForm.vue?vue&type=template&id=4aa8b32b&scoped=true"
import script from "./TipForm.vue?vue&type=script&lang=js"
export * from "./TipForm.vue?vue&type=script&lang=js"

import "./TipForm.vue?vue&type=style&index=0&id=4aa8b32b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa8b32b"]])

export default __exports__